$(document).ready(function () {

    $(document).on("click", ".confirmLink", function (e) {
        e.preventDefault();
        let link = $(this);
        let ask = "Opravdu chcete odebrat tento záznam?";

        if(isDefined(link.data("ask"))){
            ask = link.data("ask");
        }

        let confirmDialog = new ConfirmDialog(ask, {
            event: e
        });

        confirmDialog.create(function (result) {
            if(result){
                let url = link.data("href");
                let ajax = link.data("ajax");

                // Spinner overlay pro tlačítka s data-progress
                if(link.data("progress")){
                    if(typeof $.progress !== 'undefined'){
                        $.progress.insert();
                    }
                    link.addClass('disabled').css('pointer-events', 'none');
                }

                if(ajax === "on"){
                    $.nette.ajax({
                        url: url,
                        success: function (payload) {

                        }
                    });
                } else {
                    window.location.href = url;
                }
            }
        });

    });

});

$(document).ready(function() {
    // Handler for the reject button
    $(document).on("click", ".rejectLink", function(e) {
        console.log("Reject button clicked");
        e.preventDefault();
        const userId = $(this).data("id");
        console.log("User ID:", userId);

        // Store the user ID in the modal for later use
        $("#rejectModal").data("userId", userId);

        // Show the modal
        $("#rejectModal").modal("show");
    });

    $(document).on("click", "#confirmReject", function() {
        const userId = $("#rejectModal").data("userId");
        const rejectUrl = $(".rejectLink[data-id='" + userId + "']").data("rejectUrl");
        const reason = $("#rejectReason").val().trim();

        if (!reason) {
            toastr.error("Prosím zadejte důvod zamítnutí.");
            return;
        }

        $.nette.ajax({
            url: rejectUrl,
            type: "POST",
            data: {
                reason: reason
            },
            success: function(payload) {
                $("#rejectModal").modal("hide");
            }
        });
    });
});

var activityColors = {
    'blue': '#1a6ef5',
    'green': '#0d9e5f',
    'yellow': '#e6b800',
    'red': '#e53525',
    'grey': '#777777',
    'black': '#222222'
};

function activityDotHtml(state, extended) {
    if (!state.id) {
        return state.text;
    }
    var label = extended ? ' <span style="font-size:12px;margin-left:4px;">' + state.text + '</span>' : '';
    if (state.id === 'new_no_order') {
        return $('<span style="display:inline-flex;align-items:center;"><i class="far fa-question-circle" style="font-size:14px;color:#999;"></i>' + label + '</span>');
    }
    if (!activityColors[state.id]) {
        return state.text;
    }
    var c = activityColors[state.id];
    return $('<span style="display:inline-flex;align-items:center;"><span style="display:inline-block;width:14px;height:14px;border-radius:50%;background:' + c + ';background-image:radial-gradient(circle at 40% 35%, rgba(255,255,255,0.15) 0%, transparent 50%);box-shadow:0 1px 2px rgba(0,0,0,0.15);"></span>' + label + '</span>');
}

function initActivityBucketSelect2() {
    $(".select2-activity-bucket").each(function() {
        var $el = $(this);
        if ($el.data('select2')) {
            return;
        }
        $el.select2({
            templateResult: function(state) { return activityDotHtml(state, true); },
            templateSelection: function(state) { return activityDotHtml(state, false); },
            minimumResultsForSearch: Infinity
        });
        $el.on('select2:open', function() {
            var $dropdown = $el.data('select2').$dropdown;
            if ($dropdown) {
                $dropdown.addClass('select2-activity-bucket-dropdown');
            }
        });
    });
}

$(document).ready(function () {

    if(isDefined($.fn.select2)) {
        $(".select2").select2();
        initActivityBucketSelect2();
    }

    $('.custom-file-input').on('change',function() {
        let fileName = this.files[0].name;
        $(this).siblings('.custom-file-label').first().addClass("selected").html(fileName);
    });

});

$(document).ready(function() {
    if (typeof $.nette !== 'undefined') {
        $.nette.ext('maintenance', {
            complete: function (xhr) {
                try {
                    const contentType = xhr.getResponseHeader('content-type') || '';
                    if (contentType.includes('application/json')) {
                        const response = JSON.parse(xhr.responseText);
                        if (response.maintenance === true) {
                            window.location.href = response.redirect;
                            return false;
                        }
                    }
                } catch (e) {
                    // Not JSON or parsing failed, continue normally
                }
            }
        });
    }
});

$(document).ajaxComplete(function () {
    if(isDefined($.fn.select2)) {
        // Inicializace select2 na prvcích nově vykreslených AJAXem (např. formuláře ve snippetech).
        // KRITICKE: selektor musi byt "select.select2" (raw <select>), ne ".select2" — select2 lib
        // pridava class "select2" na wrapper <span>, takze ".select2" by matchnul i wrappery a kazdy
        // AJAX by vytvoril dalsi duplicitni wrapper (.select2-container) na stejnem elementu.
        // .not(".select2-hidden-accessible") preskoci uz inicializovane raw selecty.
        $("select.select2").not(".select2-hidden-accessible").select2();
        initActivityBucketSelect2();
    }
});
